function getBoundaries() {
  const $firstPageSection = document.querySelector('.page__section');
  const { top: contentStart } = $firstPageSection.getBoundingClientRect();
  const scrollTop = window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  const topOffset = 60;
  const top = (contentStart + scrollTop) - topOffset;
  const insideContent = scrollTop >= top;
  return {
    insideContent,
  };
}

function positionStickyLink($stickyLink) {
  const $firstPageSection = document.querySelector('.page__section');

  if ($firstPageSection) {
    $firstPageSection.setAttribute('style', 'position: relative;');
    $firstPageSection.appendChild($stickyLink.parentElement);
  }

  setTimeout(() => {
    $stickyLink.parentElement.setAttribute('style', 'visibility: visible');
    $stickyLink.classList.add('sticky-link--scrolled-in');
  }, 1000);
}

function fixStickyLink($stickyLink) {
  const { insideContent } = getBoundaries();

  if (insideContent) {
    $stickyLink.classList.add('sticky-link--fixed');
  } else {
    $stickyLink.classList.remove('sticky-link--fixed');
  }
}

export function toggleStickyLink($stickyLink, isVisible) {
  if (isVisible) {
    $stickyLink.classList.remove('sticky-link--hidden');
  } else {
    $stickyLink.classList.add('sticky-link--hidden');
  }
}

export function updateStickyLinkNumber($stickyLink, number) {
  const $number = $stickyLink.querySelector('.sticky-link__number');
  if ($number) {
    const $inner = $number.querySelector('.sticky-link__number-inner');
    if ($inner) $inner.textContent = number;
  }
}

document.querySelectorAll('.sticky-link').forEach(($stickyLink) => {
  if (document.querySelector('.page__content')) {
    $stickyLink.classList.add('sticky-link--positioned');
    positionStickyLink($stickyLink);
    window.addEventListener('scroll', () => fixStickyLink($stickyLink));
    $stickyLink.addEventListener('click', e => e.currentTarget.blur());
  }
});
